<template>
	<div class="troubleshooting">
		<TroubleshootingMenu tab="user"></TroubleshootingMenu>
		<div class="troubleshooting-query">
			<div>
				<label>Academy Id</label>
				<input v-model="acadid" v-validate.initial="acadid" v-on:keyup.enter="search" type="text" data-vv-rules="required|numeric" data-vv-name="Academy Id" class="text-input bg-white">
				<button :disabled="searching" v-on:click="search" class="button raised">Search</button>
				<p class="text-danger" v-if="errors.has('Academy Id')">{{ errors.first('Academy Id') }}</p>
			</div>
		</div>
		<div v-if="searching">
			<loading-bar></loading-bar>
			<p class="text-center">{{waitmsg}}</p>
		</div>
		<hr>
		<div v-if="noMappings">
			<p>No mappings found for {{acadid}}. Check to make sure Academy ID is valid.</p>
		</div>
		<div  v-if="mappingsReady" class="clearfix">
			<div class="pull-right">
				<span class="action-label">Show Raw Data:</span>
				<Toggle @change="showRaw = !showRaw" v-bind:value="showRaw"></Toggle>
			</div>
			<span class="user-count"><strong>Zombie Users (No SSO Mapping):</strong> {{zombies}}</span>
			<span class="user-count"><strong>Mismatched Users: </strong>{{mmCount}}</span>
			<button v-if="mmCount !== 0" v-on:click="getReport">Download Mismatched Users Report</button>
		<hr>
		</div>

		<div v-show="!showRaw">
			<div v-if="detaillUser">
				<button class="pull-right" v-on:click="clearDetails">Return to User List</button>
				<h3>User Details</h3>
				<user-details v-bind:user="detaillUser" v-bind:acadid="acadid"></user-details>
			</div>

			<div v-show="!detaillUser" v-if="mappingsReady" class="search-result">
				<v-client-table :data="rows" :columns="columns" :options="options"></v-client-table>
			</div>
		</div>

		<div v-if="showRaw">
			<button  v-if="detaillUser" class="pull-right" v-on:click="detaillUserIndex = null">Return to User List</button>
			<h3>Raw Results Data</h3>
			<div class="rawResult"><pre>{{rawData}}</pre></div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import _ from 'underscore'
import Toggle from './Toggle'
import TroubleshootingMenu from './TroubleshootingMenu'
import api from '../services/api.js'

const bus = new Vue()

const detailsTemplate = (h, row) => {
	return h('user-detail-button', {
		attrs: {
			'index': row['index']
		}
	})
}
const mapuser = (user, i) => ({
	'Schoox User Name': user.schooxUserName,
	'Schoox Id': user.schooxId,
	'Hrid': user.hrid,
	'HS User Name': user.hsUserName,
	'HS User Email': user.hsUserEmail,
	'HS Ids': _.isArray(user.hsIds) ? user.hsIds.join(', ') : user.hsIds,
	'HS User Count': user.hsUserCount,
	'Action Count': user.actionCount,
	'Mismatched Name': user.mismatchedName ? 'true' : '',
	'Locations': user.locations,
	'index': i
})

Vue.component('user-detail-button', {
	props: ['index'],
	template: '<button v-on:click="showDetails">View</button>',
	methods: {
		showDetails: function (e) {
			bus.$emit('details', this.index)
			e.preventDefault()
		}
	}
})

export default{
	name: 'Troubleshooting',
	components: {
		'user-details': require('./UserDetails'),
		TroubleshootingMenu,
		Toggle
	},
	data () {
		return {
			acadid: '',
			showRaw: false,
			columns: [ 'Schoox User Name', 'Schoox Id', 'Hrid', 'HS User Name', 'HS User Email', 'HS Ids', 'Locations', 'HS User Count', 'Action Count', 'Mismatched Name', 'Details' ],
			options: {
				perPage: 25,
				templates: {
					'Details': detailsTemplate
				}
			},
			detaillUserIndex: null,
			showUserDetail: false
		}
	},
	computed: {
		waitmsg () {
			return this.$store.state.usermappings.msg
		},
		searching () {
			return this.$store.state.troubleshooting.searching
		},
		resultsFor () {
			let s = ''
			if (!_.isEmpty(this.hsid)) {
				s += ' HotSchedules id: ' + this.hsid
			}
			if (!_.isEmpty(this.schooxid)) {
				s += ' Schoox id: ' + this.schooxid
			}
			return s
		},
		// temp to show raw JSON
		mappings () {
			return this.$store.state.usermappings.data
		},
		rawData () {
			let data = (this.detaillUser) ? this.detaillUser : this.$store.state.usermappings.data
			return JSON.stringify(data, undefined, 2)
		},
		mappingsReady () {
			return this.$store.state.usermappings.data && this.$store.state.usermappings.data.length
		},
		noMappings () {
			return this.$store.state.usermappings.ready && this.$store.state.usermappings.data && !this.$store.state.usermappings.data.length
		},
		detaillUser () {
			let u = this.$store.state.usermappings.details
			return _.isArray(u) ? u[0] : u
		},
		showList () {
			return !_.isNull(this.detaillUserIndex)
		},
		report () {
			return '/academy/' + this.acadid + '/mismatchedNames.csv'
		},
		rows () {
			return _.map(this.$store.state.usermappings.data, mapuser)
		},
		zombies () {
			let data = this.$store.state.usermappings.data

			if (!data || !data.length) return 0

			return _.filter(this.$store.state.usermappings.data, (row) => row.hsUserCount < 1).length
		},
		mmCount () {
			let data = this.$store.state.usermappings.data

			if (!data || !data.length) return 0

			return _.filter(this.$store.state.usermappings.data, (row) => row.mismatchedName === true).length
		}
	},
	methods: {
		search () {
			this.$validator.validateAll()

			if (!this.errors.any()) {
				this.stopPoll = this.$watch(() => this.$store.state.usermappings.pollCount, () => this.pollData())
				this.$store.dispatch('getUserMappings', { id: this.acadid })
			}
		},
		showDetails (i) {
			console.log('Select user', this.getSchooxId(i))
			// this.detaillUserIndex = index
			this.$store.dispatch('getUserDetails', {
				acadid: this.acadid,
				schooxid: this.getSchooxId(i),
				hsids: this.getHsIds(i)
			})
		},
		pollData () {
			if (this.$store.state.usermappings.ready) {
				this.stopPoll()
			} else {
				this.pollTimer = _.delay(() => this.$store.dispatch('getUserMappings', { id: this.acadid }), 1000)
			}
		},
		getReport () {
			return api.getMissMatchReport(this.acadid)
		},
		getSchooxId (i) {
			return this.$store.state.usermappings.data[i].schooxId
		},
		getHsIds (i) {
			return this.$store.state.usermappings.data[i].hsIds
		},
		clearDetails () {
			this.$store.dispatch('clearUserDetails')
		}
	},
	created () {
		bus.$on('details', this.showDetails)
	},
	beforeMount () {
		if (this.$route.params.acadid) {
			this.acadid = this.$route.params.acadid
			this.search()
		}
	},
	beforeDestroy () {
		clearTimeout(this.pollTimer)
		if (_.isFunction(this.stopPoll)) {
			this.stopPoll()
		}
		this.$store.dispatch('clearUserMappings')
	}
}

</script>

<style>
.user-count{
	padding-right: 15px;
}
</style>


// WEBPACK FOOTER //
// Troubleshooting.vue?70a18bd8